import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Stack,
} from "@mui/material";
import Close from "@mui/icons-material/Close";
import CopyableTypography from "components/Typography/CopyableTypography";

interface NaicsCodesModalProps {
  open: boolean;
  onClose: () => void;
  codes: number[];
}

export function NaicsCodesModal({
  open,
  onClose,
  codes,
}: NaicsCodesModalProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          NAICS Codes ({codes.length})
        </Typography>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 2.5, pb: 3 }}>
        {codes.length === 0 ? (
          <Typography color="text.secondary" sx={{ py: 2 }}>
            No NAICS codes found
          </Typography>
        ) : (
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {codes.map((code) => (
              <CopyableTypography
                key={code}
                text={String(code)}
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  px: 1,
                  py: 0.5,
                  borderRadius: 1,
                  border: "1px solid",
                  borderColor: "divider",
                }}
              />
            ))}
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
}
